// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"418":"9f369b1064b48276432e","1267":"7fdf76627e00dee9cdf2"}[chunkId] + ".chunk.css";
};